import * as React from 'react';

function SvgDollar(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
            fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12.9849 6.99918C13.5223 6.98441 14.054 7.11435 14.5242 7.37558C14.9998 7.6398 15.3946 8.02839 15.6664 8.49975L13.9336 9.49861C13.8431 9.34149 13.7115 9.21197 13.5529 9.12389C13.3944 9.03582 13.2149 8.99251 13.0336 8.99861L13.0168 8.99918H11C10.7348 8.99918 10.4804 9.10454 10.2929 9.29207C10.1054 9.47961 10 9.73396 10 9.99918C10 10.2644 10.1054 10.5187 10.2929 10.7063C10.4804 10.8938 10.7348 10.9992 11 10.9992H13C13.7957 10.9992 14.5587 11.3153 15.1213 11.8779C15.6839 12.4405 16 13.2035 16 13.9992C16 14.7948 15.6839 15.5579 15.1213 16.1205C14.5587 16.6831 13.7957 16.9992 13 16.9992H11.0151C10.4777 17.014 9.94598 16.884 9.47578 16.6228C9.00017 16.3586 8.60538 15.97 8.33365 15.4986L10.0664 14.4997C10.1569 14.6569 10.2885 14.7864 10.4471 14.8745C10.6056 14.9625 10.7851 15.0058 10.9664 14.9997L10.9832 14.9992H13C13.2652 14.9992 13.5196 14.8938 13.7071 14.7063C13.8946 14.5187 14 14.2644 14 13.9992C14 13.734 13.8946 13.4796 13.7071 13.2921C13.5196 13.1045 13.2652 12.9992 13 12.9992H11C10.2043 12.9992 9.44129 12.6831 8.87868 12.1205C8.31607 11.5579 8 10.7948 8 9.99918C8 9.20353 8.31607 8.44047 8.87868 7.87786C9.44129 7.31525 10.2043 6.99918 11 6.99918H12.9849Z"
            fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13 6V8H11V6H13ZM11 18V16H13V18H11Z" fill="currentColor"/>
    </svg>
  );
}

export default SvgDollar;
